import { DeficiencyTypes } from '@core/enums/deficiency-types';

export class Deficiency {
  public constructor(
    public deficiencyType: DeficiencyTypes,
    public equipmentId: string,
    public equipmentName: string,
    public cml: string,
    public finding: string,
    public ispRecommendation: string,
    public aoComment: string,
    public eventId: string,
    public circuitId: string,
    public projectId: string,
  ) {}
}
